import { render, staticRenderFns } from "./drawerDossier.vue?vue&type=template&id=5fb7d3be&"
import script from "./drawerDossier.vue?vue&type=script&lang=js&"
export * from "./drawerDossier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports